
export const BuyerNotifyMutation = new TypedDocumentString(`
    mutation BuyerNotifyMutation($input: InputBuyerNotify!) {
  buyerNotify(input: $input) {
    responseInfo {
      ...ResponseInfo
      __typename
    }
    doc {
      ...BuyerNotifyDoc
      __typename
    }
    __typename
  }
}
    fragment ResponseInfo on ResponseInfo {
  success
  message
  status
  error
  __typename
}
fragment BuyerNotifyDoc on BuyerNotifyDoc {
  id
  productId
  isActive
  type
  onPriceDrop
  __typename
}`, {"hash":"6d645110535bd534154788cbddc197a7d40d48c81c19e6a99aae0ba0c0f0f200"});